"use client"

import { RegistrationForm } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/RegistrationForm"
import { WeeklyLeaflet } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/WeeklyLeaflet"
import { ContactList } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ContactList"
import { HeaderGroup } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeaderGroup"
import { NewsSwiper } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/NewsSwiper"
import { Config } from "@measured/puck"
import { Box } from "./blocks/Box"
import { Button } from "./blocks/Button"
import { Columns } from "./blocks/Columns"
import { Container } from "./blocks/Container"
import { EmailSubscription } from "./blocks/EmailSubscription"
import { EmbedHtml } from "./blocks/EmbedHtml"
import { Heading } from "./blocks/Heading"
import { Image as ImageConfig } from "./blocks/Image"
import { ImageCard } from "./blocks/ImageCard"
import { MapDisplay } from "./blocks/MapDisplay"
import { PhotoLibrary } from "./blocks/PhotoLibrary"
import { PostGrid as PostGridConfig } from "./blocks/PostGrid"
import { PostGridByCategory as PostGridByCategoryConfig } from "./blocks/PostGridByCategory"
import { SimpleSlider as SimpleSliderConfig } from "./blocks/SimpleSliders"
import { CustomTabs } from "./blocks/Tabs"
import { Text } from "./blocks/Text"
import { VericalSpace } from "./blocks/VerticalSpace"
import { Video as VideoConfig } from "./blocks/Video"
import { VideoLibrary } from "./blocks/VideoLibrary"
import { CategoryBannerLayout } from "./themes/tamda-media/CategoryBannerLayout"
import { SectionBannerSidebar } from "./themes/tamda-media/SectionBannerSidebar"
import { TamdaMediaFooter } from "./themes/tamda-media/TamdaMediaFooter"
import { TamdaMediaHeader } from "./themes/tamda-media/TamdaMediaHeader"
import { TamdaMediaNewsLayout } from "./themes/tamda-media/TamdaMediaNewsLayout"
import { VideoCategoryGridLayout } from "./themes/tamda-media/VideoCategoryGridLayout"
import { VideoCategoryLayout } from "./themes/tamda-media/VideoCategoryLayout"
import { AboutUsSection } from "./themes/tamda-one/AboutUsSection"
import { AboutUsTimeline } from "./themes/tamda-one/AboutUsTimeline"
import { BannerCarousel } from "./themes/tamda-one/BannerCarousel"
import { BecomeTDFCustomer } from "./themes/tamda-one/BecomeTDFCustomer"
import { Career } from "./themes/tamda-one/Career"
import { CategoryExpress } from "./themes/tamda-one/CategoryExpress"
import { CompanyList } from "./themes/tamda-one/CompanyList"
import { FieldOfActivity } from "./themes/tamda-one/FieldOfActivity"
import { FooterGroup } from "./themes/tamda-one/FooterGroup"
import { HeroBannerLayout } from "./themes/tamda-one/HeroBannerLayout"
import { HeroBannerWithBreadcrumb } from "./themes/tamda-one/HeroBannerWithBreadcrumb"
import { MemberList } from "./themes/tamda-one/MemberList"
import { NotificationList } from "./themes/tamda-one/NotificationList"
import { PromotionBottomBanner } from "./themes/tamda-one/PromotionBottomBanner"
// import { PromotionList } from "./themes/tamda-one/PromotionList"
import { LatestNews } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/LatestNews"
import { PostGridByCategory } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/PostGridByCategory"
import { StoreInfo } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo"
import { StoreLocator } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator"
import { SupplierGrid } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/SupplierGrid"
import { Video } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/Video"
import { EventGrid } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/EventGrid"
import { TamdaExpressProductList } from "./themes/tamda-express/TamdaExpressProductList"
import { ContactStoreInfo } from "./themes/tamda-one/ContactStoreInfo"
import { EventCarousel } from "./themes/tamda-one/EventCarousel"
import { FAQs } from "./themes/tamda-one/FAQs"
import { PromotionList } from "./themes/tamda-one/PromotionList"
import { PromotionShowcase } from "./themes/tamda-one/PromotionShowcase"
import { QuestionAndAnswer } from "./themes/tamda-one/QuestionAndAnswer"
import { QuickLinks } from "./themes/tamda-one/QuickLinks"
import { QuickService } from "./themes/tamda-one/QuickService"
import { ServiceGridList } from "./themes/tamda-one/ServiceGridList"
import { ServiceShowcase } from "./themes/tamda-one/ServiceShowcase"
import { ServiceSidebar } from "./themes/tamda-one/ServiceSidebar"
import { VisionAndMission } from "./themes/tamda-one/VisionAndMission"
import { WhyChooseUs } from "./themes/tamda-one/WhyChooseUs"
import { WidgetRegistration } from "./themes/tamda-one/WidgetRegistration"

// Components
// Below components config is used for renderer only

const uiBuilderComponents = {
  //layout
  Container,
  Columns,
  Box,
  VericalSpace,

  //content
  Heading,
  Text,
  Button,
  EmbedHtml,
  EmailSubscription,
  MapDisplay,

  //media
  ImageCard,
  PhotoLibrary,
  VideoLibrary,
  VideoConfig,
  ImageConfig,

  //Loop data
  SimpleSliderConfig,
  PostGridByCategoryConfig,
  PostGridConfig,
  CategoryBannerLayout,
  CustomTabs,
  //Tamda Media
  TamdaMediaHeader,
  HeaderGroup,
  TamdaMediaFooter,
  FieldOfActivity,
  FooterGroup,
  MemberList,
  AboutUsSection,
  TamdaMediaNewsLayout,
  VideoCategoryLayout,
  VideoCategoryGridLayout,
  SectionBannerSidebar,
  HeroBannerLayout,
  HeroBannerWithBreadcrumb,
  AboutUsTimeline,
  QuickLinks,
  VisionAndMission,
  NewsSwiper,
  ServiceShowcase,
  Career,
  BannerCarousel,
  PromotionBottomBanner,
  CompanyList,
  WhyChooseUs,
  // PromotionList,
  NotificationList,
  CategoryExpress,
  QuickService,
  ServiceGridList,
  WidgetRegistration,
  BecomeTDFCustomer,
  QuestionAndAnswer,
  PromotionShowcase,
  PromotionList,
  ServiceSidebar,
  WeeklyLeaflet,
  Video,
  RegistrationForm,
  StoreInfo,
  StoreLocator,
  SupplierGrid,
  FAQs,
  ContactList,
  LatestNews,
  ContactStoreInfo,
  PostGridByCategory,
  EventCarousel,
  TamdaExpressProductList,
  EventGrid,
}

// primary config
export const configUi = {
  categories: {
    layout: {
      title: "Layout",
      components: ["Container", "Columns", "Box", "VericalSpace"],
    },
    content: {
      title: "Content",
      components: ["Heading", "Text", "Button", "EmbedHtml"],
    },
    media: {
      title: "Media",
      components: ["ImageConfig", "ImageCard", "VideoConfig", "PhotoLibrary", "VideoLibrary"],
    },
    data: {
      title: "Data",
      components: ["SimpleSliderConfig", "PostGridByCategoryConfig", "PostGridConfig", "CustomTabs"],
    },
    TAMDA_MEDIA: {
      title: "Tamda Media",
      components: [
        "TamdaMediaHeader",
        "CategoryBannerLayout",
        "TamdaMediaFooter",
        "FieldOfActivity",
        "TamdaMediaNewsLayout",
        "VideoCategoryLayout",
        "VideoCategoryGridLayout",
        "SectionBannerSidebar",
      ],
    },
    TAMDA_GROUP: {
      title: "Tamda Group",
      components: [
        "HeaderGroup",
        "FieldOfActivity",
        "FooterGroup",
        "MemberList",
        "AboutUsSection",
        "HeroBannerWithBreadcrumb",
        "HeroBannerLayout",
        "AboutUsTimeline",
        "VisionAndMission",
        "QuickLinks",
        "NewsSwiper",
        "ServiceShowcase",
        "QuickService",
        "ServiceGridList",
        "Career",
        "BannerCarousel",
        "PromotionBottomBanner",
        "CompanyList",
        "WhyChooseUs",
        // "PromotionList",
        "NotificationList",
        "CategoryExpress",
        "WidgetRegistration",
        "BecomeTDFCustomer",
        "QuestionAndAnswer",
        "PromotionShowcase",
        "PromotionList",
        "ServiceSidebar",
        "FAQs",
        "ContactList",
        "ContactStoreInfo",
        "EventCarousel",
        "EventGrid",
      ],
    },
    TAMDA_FOODS: {
      title: "Tamda Foods",
      components: [
        "WeeklyLeaflet",
        "Video",
        "RegistrationForm",
        "StoreInfo",
        "StoreLocator",
        "LatestNews",
        "PostGridByCategory",
        "SupplierGrid",
      ],
    },
    TAMDA_EXPRESS: {
      title: "Tamda Express",
      components: ["TamdaExpressProductList"],
    },
  },

  root: {
    fields: {
      title: {
        type: "text",
        label: "Title",
      },
      breadcrumb: {
        type: "array",
        label: "Bread Crumb",
        min: 0,
        max: 4,
        arrayFields: {
          title: {
            type: "text",
            label: "Title",
          },
          link: {
            type: "text",
            label: "Link",
          },
        },
      },
    },
  },
}

// @ts-ignore
export const uiBuilderConfig: Config = {
  components: {
    //default components
    ...uiBuilderComponents,

    // Theme components
  },
  ...configUi,
}
